import { SearchQConfigsDocument, useDeleteQConfigMutation } from '@exam-management/graphql';
import { useNavigate, useParams } from '@exam-management/router';
import { ConfirmationModal, type ConfirmationModalProps, Text } from '@shared/components';
import { useSnackbar } from '@shared/snackbar';

interface DeleteQConfigModalProps extends Omit<ConfirmationModalProps, 'content' | 'title'> {
  qconfigId: string;
  onClose: () => void;
}
export default function DeleteQConfigModal(props: Readonly<DeleteQConfigModalProps>) {
  const { onClose, qconfigId, ...restProps } = props;
  const { courseId } = useParams('/exam-courses/:courseId/qconfigs/:qconfigId');
  const navigate = useNavigate();
  const { showSnackbar } = useSnackbar();

  const [deleteQConfig, { loading: isDeleteQConfigLoading }] = useDeleteQConfigMutation({
    onCompleted: () => {
      showSnackbar({
        message: 'QConfig has been deleted',
        variant: 'success',
      });
      navigate('/exam-courses/:courseId/qconfigs', { replace: true, params: { courseId } });
    },
    onError: () => {
      showSnackbar({
        message: 'Unable to Delete QConfig',
        variant: 'error',
      });
    },
    awaitRefetchQueries: true,
    refetchQueries: [SearchQConfigsDocument],
  });

  const handleDeleteQConfig = async () => {
    await deleteQConfig({ variables: { deleteQConfigInput: { qConfigId: qconfigId } } });
    onClose();
  };

  return (
    <ConfirmationModal
      {...restProps}
      title='Delete QConfig?'
      content={<Text>คุณต้องการลบ QConfig นี้ใช่หรือไม่?</Text>}
      onDiscard={onClose}
      acceptText='Delete'
      variant='error'
      onClose={onClose}
      loading={isDeleteQConfigLoading}
      onAccept={handleDeleteQConfig}
    />
  );
}
